export class Main {
    constructor(scene) {
        this.scene = scene;

        //setings
        this.symbolHeight = 150;
        this.symbolWidth = 150;
        this.spaceBetweenReels = 0;
        this.frameTopOffset = -45;
        this.reelsOffsetTop = 390 + this.frameTopOffset;
        this.spinningRowsCount = 6;//visible + 2 hidden
        this.visibleRowsCount = 3;
        this.spinTimes = 1;
        this.initialSpinSpeed = 45;
        this.currentSpinSpeed = 45;
        this.initialAnimationSpeed = 300;
        this.initialAnimationStep = 40;
        this.stopAnimationSpeed = 200;
        this.stopAnimationStep = 75;
        this.startTimeoutBetweenReels = 70;
        this.frameMaskHeight = 455;
        this.frameMaskOffset = 80;
        this.symbolsOffsetLeft = 103;
        this.speed = 0;
        this.symbolBlurFrame = 0;
        this.symbolNormalFrame = 0;
        this.frameLeftOffset = 0;
        this.destinationOffset = 0;
        this.reelBackgroundHorizontalPadding = 0;
        this.reelBackgroundVerticalPadding = 0;
        this.reelBackgroundOffsetY = 0;
        this.underSymbolsReel = false;
        this.symbolsFadeSprite = false;
        this.symbolsFadeOffsetX = 0;
        this.symbolsFadeOffsetY = 0;

        this.reels = Config.reels;
        this.reelsAnimations = Config.settings.reels_animations ? Config.settings.reels_animations : null;

        //game objects
        this.reelsContainersObjects = {};
        this.underSymbolsReelItems = {};
        this.frameContainer = null;
        this.symbolsAndPaylinesContainer = null;
        this.spinStarted = false;
        this.reelsSpinning = 0;
        this.spinningScaleX = 1;
        this.spinningScaleY = 1;
        this.resetSlot = false;

        this.symbols = Config.symbols.reduce((obj, item) => Object.assign(obj, {[item.name]:{"type":item.type, "size":item.size} }), {});

        this.spinType = 'default';

        Config.symbolsTextureData = {};
    }

    spin() {
        this.spinStarted = true;
        this.prepareReels();
    }

    getNextIndexToSpin(reelIndex, symbolIndex) {
        let nextIndex = parseInt(symbolIndex) - (this.visibleRowsCount+2);

        if(nextIndex < 0) {
            nextIndex = this.reelsContainersObjects[reelIndex].length + nextIndex;
        }

        return nextIndex;
    }

    getNextSymbolToSpin(reelIndex, symbolIndex){
        const nextIndex = this.getNextIndexToSpin(reelIndex, symbolIndex);
        return this.reelsContainersObjects[reelIndex].symbols[nextIndex];
    }

    getAfterSymbol(reelIndex, symbolIndex){
        const afterIndex = this.getAfterSymbolIndex(reelIndex, symbolIndex);
        return this.reelsContainersObjects[reelIndex].symbols[afterIndex];
    }

    getAfterSymbolIndex(reelIndex, symbolIndex) {
        let afterIndex = parseInt(symbolIndex) - 1;
        
        if(afterIndex > this.reelsContainersObjects[reelIndex].symbols.length-1) {
            afterIndex = afterIndex - this.reelsContainersObjects[reelIndex].symbols.length;
        }

        if(afterIndex < 0) {
            afterIndex = this.reelsContainersObjects[reelIndex].symbols.length + afterIndex;
        }

        return parseInt(afterIndex);
    }

    getPrevSymbolIndex(reelIndex, symbolIndex) {
        let prevIndex = parseInt(symbolIndex) + 1;

        if(prevIndex > this.reelsContainersObjects[reelIndex].symbols.length-1) {
            prevIndex = prevIndex - this.reelsContainersObjects[reelIndex].symbols.length;
        }

        if(prevIndex < 0) {
            prevIndex = this.reelsContainersObjects[reelIndex].symbols.length + prevIndex;
        }

        return parseInt(prevIndex);
    }

    getPrevSymbol(reelIndex, symbolIndex){
        const prevIndex = this.getPrevSymbolIndex(reelIndex, symbolIndex);

        return this.reelsContainersObjects[reelIndex].symbols[prevIndex];
    }

    fixToFinalPositions(reel) {
        for(let i = -1; i < this.spinningRowsCount-1; i++) {
            const index = reel.offsetPosition+i;
            const symbol = this.getAfterSymbol(reel.reelIndex, index);
            const position = i-1;
            symbol.positionOnReel = position;

            symbol.y = this.getSymbolCoordinateY(position, symbol);
        }
    }

    getStartPositionBeforeMove(reelIndex, symbolIndex, symbol) {
        let prevSymbol = this.getPrevSymbol(reelIndex, symbolIndex);

        let prevSymbolY = prevSymbol.y;
        let offsetY = this.symbolHeight / symbol.sizeOnReel;

        if(symbol.sizeOnReel > 1) {
            const diff = this.visibleRowsCount - symbol.sizeOnReel;
            if (diff === 0) {
                offsetY = 0;
            }
        }
        
        if(prevSymbol.sizeOnReel > 1) {
            return prevSymbol.y - ((this.symbolHeight / 2) * (prevSymbol.sizeOnReel + 1));
        }

        return prevSymbolY - offsetY;
    }

    getSymbolCoordinateY(positionOnReel, symbol) {
        let symbolHeight = this.getSymbolHeight();
        let pos = symbolHeight * positionOnReel - symbolHeight;

        if(symbol.sizeOnReel > 1) {
            const centerPos = -(symbolHeight);

            return centerPos + ((symbol.sizeOnReel - 1) * (symbolHeight / 2)) + (positionOnReel * symbolHeight) + this.reelsOffsetTop;
        }

        return pos + this.reelsOffsetTop;
    }

    createSlotMachine() {
        this.frame = this.scene.add.sprite(this.frameLeftOffset, this.scene.yCenterPoint + this.frameTopOffset, 'frame').setOrigin(0.5, 0.5);
        this.createReelsMask();
        
        this.frameContainer = this.scene.add.container();
        this.symbolsAndPaylinesContainer = this.scene.add.container();
        this.frameContainer.x = this.scene.cameras.main.centerX;
        this.frameContainer.y = 0;
        this.symbolsAndPaylinesContainer.x = this.scene.cameras.main.centerX;
        this.symbolsAndPaylinesContainer.y = 0;
        this.frameContainer.add(this.frame);

        this.createReels();
        this.frameContainerFront = this.scene.add.container();
        this.addBackgrounds();
        this.scene.canvasReady();
    }

    createReelsMask(offsetX, offsetY) {
        if(!this.reelsContainer) {
            return;
        }

        offsetY = offsetY ? offsetY : 0;

        if(this.mask) {
            this.reelsContainer.clearMask();
            this.mask.destroy();
        }

        if (typeof this.scene.customMask === 'function') { 
            this.scene.customMask();
        } else {
            let posX = this.frame.x - ((this.frame.width * this.frameContainer.scale) / 2) + this.scene.cameras.main.centerX;
    
            if(offsetX) {
                posX += offsetX;
            }
           
            const posY = (this.frame.y + this.frameContainer.y - (this.frame.height / 2)) + this.frameMaskOffset + offsetY;

            let shape = this.scene.make.graphics().fillRect(posX, posY, this.frame.width * this.frameContainer.scale, this.frameMaskHeight * this.frameContainer.scale);
    
            this.mask = shape.createGeometryMask();
            this.reelsContainer.setMask(this.mask);
        }
    }

    addBackgrounds() {
        for(const [ reelIndex, reel ] of Object.entries(this.reelsContainersObjects)) {
            if(reel.background) {
                reel.background.destroy();
            }

            const posY = this.frame.y - ((this.frame.height + this.reelBackgroundVerticalPadding) / 2) + this.frameMaskOffset;
            const posX = reel.x - (this.symbolWidth + this.reelBackgroundHorizontalPadding) / 2;

            reel.background = this.scene.add.graphics().fillStyle(0x000000, 1).fillRect(0, this.reelBackgroundVerticalPadding, this.symbolWidth + this.reelBackgroundHorizontalPadding, this.frameMaskHeight);
            reel.background.x = posX;
            reel.background.y = posY + this.reelBackgroundOffsetY;
            reel.background.alpha = 0;
            this.frameContainerFront.add(reel.background);
        }

        if(this.scene.outsideFrame) {
            this.frameContainerFront.bringToTop(this.scene.outsideFrame);
        }
    }

    speedUpSpin() {
        this.currentSpinSpeed = this.initialSpinSpeed * 2;

        if(this.currentSpinSpeed > (this.symbolHeight - 20)) {
            this.currentSpinSpeed = this.symbolHeight - 20;
        }

        this.reelsContainersObjects[1].spinCount = this.spinTimes;
    }

    resetSpinSpeed() {
        this.currentSpinSpeed = this.initialSpinSpeed;
    }

    toggleSpeed(value) {
        this.speed = value;

        if(value) {
            this.speedUpSpin();
        } else {
            this.resetSpinSpeed();
        }
    }

    getSymbolHeight() {
        let height = this.symbolHeight;

        return height;
    }

    createSymbolSprite(reelIndex, reel, symbolIndex, symbol, appended) { 
        let sizeOnReel = 1;
        let append = "";
        let possibleSymbolSize = parseInt(this.symbols[symbol].size);
        let reverseAppend = false;
        let needAppend = false;

        if(!appended && possibleSymbolSize) {
            needAppend = true;
            var underSymbolIndex = undefined;
            
            for(let i = 1; i < possibleSymbolSize; i++) {
                underSymbolIndex = parseInt(symbolIndex) + i;

                if(underSymbolIndex > Object.keys(reel).length-1) {
                    reverseAppend = true;
                }

                if(underSymbolIndex > Object.keys(reel).length-1) {
                    underSymbolIndex = underSymbolIndex - Object.keys(reel).length;
                }

                let symbolOnreel = this.reelsContainersObjects[reelIndex].symbols[underSymbolIndex];

                if(reel[underSymbolIndex] !== symbol || (symbolOnreel && (symbolOnreel.appended || symbolOnreel.sizeOnReel > 1))) {
                    needAppend = false;
                    break;
                }
            }

            if(needAppend) {
                sizeOnReel = parseInt(this.symbols[symbol].size);
                append = `_${sizeOnReel}`;
            }
        }

        const symbolSprite = this.scene.add.sprite(0, 0, `symbol_${symbol}${append}_spritesheet`).setOrigin(0.5, 0.5);
        symbolSprite.alpha = 0;

        symbolSprite.sizeOnReel = sizeOnReel;
        symbolSprite.indexOnReel = parseInt(symbolIndex);
        symbolSprite.appended = appended;
        symbolSprite.symbolName = symbol;
        symbolSprite.reelIndex = reelIndex;

        if(appended) {
            symbolSprite.append_parent = this.getPrevSymbol(reelIndex, symbolIndex - (this.symbols[symbol].size - appended + 1));
        }

        if(needAppend && reverseAppend) {
            for(let i = 1; i < possibleSymbolSize; i++) {
                let underSymbolIndex = parseInt(symbolIndex) + i;
                
                if(underSymbolIndex > Object.keys(reel).length-1) {
                    underSymbolIndex = underSymbolIndex - Object.keys(reel).length;
                }
                
                let addedSymbol = this.reelsContainersObjects[reelIndex].symbols[underSymbolIndex];
                
                if(addedSymbol) {
                    addedSymbol.appended = possibleSymbolSize - i;
                    addedSymbol.alpha = 0;
                    addedSymbol.append_parent = symbolSprite;
                }
            }
        }
        
        if(sizeOnReel == 1 && ! Config.symbolsTextureData[symbol]) {
            Config.symbolsTextureData[symbol] = symbolSprite.texture.source[0];
        }

        return symbolSprite;
    }

    symbolsOffsetX() {
        return (this.frame.x - this.frame.width / 2) + this.symbolsOffsetLeft;
    }

    changeOpacityOfSymbols(alpha, onlyVisibles) {
        for (const [ reelIndex, reel ] of Object.entries(this.reelsContainersObjects)) {
            for (const [ symbolIndex, symbol ] of Object.entries(reel.symbols)) {
                if(! onlyVisibles || (symbol.positionOnReel > -1 && this.visibleRowsCount > symbol.positionOnReel)) {
                    if(symbol.appended && symbol.append_parent) {
                        symbol.append_parent.alpha = alpha;
                    } else {
                        symbol.alpha = alpha;
                    }
                }
            }
        }
    }

    unblurAllReels() {
        for(const [ reelIndex, reel ] of Object.entries(this.reelsContainersObjects)) {
            this.unblurSymbols(reel);
        }
    }

    unblurSymbols(reel) {
        for (const [ symbolIndex, symbol ] of Object.entries(reel.symbols)) {
            symbol.setScale(1, 1);//neded was set some spinning scale

            if(!symbol.appended) {
                symbol.setFrame(this.symbolNormalFrame);
            }
        }
    }

    getSymbolOnReelPosition(reelIndex, symbolAbsolutePosition) {
        let positionOnReel = this.reelsContainersObjects[reelIndex].offsetPosition + symbolAbsolutePosition;

        if(positionOnReel > this.reelsContainersObjects[reelIndex].symbols.length-1) {
            positionOnReel = positionOnReel - this.reelsContainersObjects[reelIndex].symbols.length;
        }

        return this.reelsContainersObjects[reelIndex].symbols[positionOnReel];
    }

    getLastSpinningSymbol(reelIndex) {
        //filtering because sometimes after delete array item length is wrong
        let filtered = this.spinningReels[reelIndex].filter((val) => { return val });

        return filtered[filtered.length-1];
    }

    update() {}

    getSymbolAt(reelIndex, symbolIndex) {
        if(symbolIndex > this.reelsContainersObjects[reelIndex].symbols.length-1) {
            symbolIndex = symbolIndex - this.reelsContainersObjects[reelIndex].symbols.length;
        }

        return this.reelsContainersObjects[reelIndex].symbols[symbolIndex];
    }

    resetSlotSpin() {
        if(this.spinStarted) {
            this.resetSlot = true;
            let reelsScenario = {};

            for(const [ reelIndex, reel ] of Object.entries(this.reelsContainersObjects)) {
                reelsScenario[reelIndex] = reel.offsetPosition;
            }

            this.spinStartedAt -= 5000;

            this.scene.request.scenario.reels = reelsScenario;
        }
    }

    gotScenario(scenario) {
        this.prepareAnimations(scenario);
    }

    prepareAnimations(scenario) {
    }
}